(() => {
  if (window.__storeOffersDelegated) return;
  window.__storeOffersDelegated = true;

  const MODAL_VARS = [
    '--store-offers-heading-color',
    '--store-offers-text-color',
    '--store-offers-muted-color',
    '--store-offers-accent-color',
    '--store-offers-card-bg',
    '--store-offers-note-bg',
    '--store-offers-modal-bg',
    '--store-offers-overlay-bg'
  ];

  const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(input);
      return true;
    } catch (error) {
      document.body.removeChild(input);
      return false;
    }
  };

  const applyRootVarsToModal = (modal, root) => {
    if (!modal || !root) return;
    const styles = getComputedStyle(root);
    MODAL_VARS.forEach((name) => {
      const value = styles.getPropertyValue(name).trim();
      if (value) modal.style.setProperty(name, value);
    });
  };

  const openModal = (modal, root) => {
    if (!modal) return;

    applyRootVarsToModal(modal, root || modal.closest('[data-store-offers-root]'));

    // Move to body so it sits above Quick Buy and covers the full viewport
    if (modal.parentElement !== document.body) {
      if (!modal._storeOfferOriginalParent) {
        modal._storeOfferOriginalParent = modal.parentElement;
        modal._storeOfferOriginalNext = modal.nextSibling;
      }
      document.body.appendChild(modal);
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      modal.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('store-offers-modal-open');
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      modal.hidden = true;

      const originalParent = modal._storeOfferOriginalParent;
      if (originalParent && modal.parentElement === document.body) {
        if (modal._storeOfferOriginalNext && modal._storeOfferOriginalNext.parentNode === originalParent) {
          originalParent.insertBefore(modal, modal._storeOfferOriginalNext);
        } else {
          originalParent.appendChild(modal);
        }
      }
    }, 320);
    document.documentElement.style.overflow = '';
    document.body.classList.remove('store-offers-modal-open');
  };

  document.addEventListener('click', async (event) => {
    const copyButton = event.target.closest('[data-store-offer-copy]');
    if (copyButton) {
      const code = copyButton.getAttribute('data-copy-code');
      if (!code) return;

      const copied = await copyToClipboard(code);
      const card = copyButton.closest('.store-offers__card');
      const feedback = card ? card.querySelector('[data-store-offer-feedback]') : null;

      if (copied && feedback) {
        feedback.hidden = false;
        window.clearTimeout(feedback._hideTimer);
        feedback._hideTimer = window.setTimeout(() => {
          feedback.hidden = true;
        }, 1800);
      }
      return;
    }

    const openButton = event.target.closest('[data-store-offer-open]');
    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      const modalId = openButton.getAttribute('data-store-offer-open');
      if (!modalId) return;

      const root = openButton.closest('[data-store-offers-root]');
      const modal = (root && root.querySelector('#' + CSS.escape(modalId)))
        || document.getElementById(modalId);
      openModal(modal, root);
      return;
    }

    const closeButton = event.target.closest('[data-store-offer-close]');
    if (closeButton) {
      const modal = closeButton.closest('.store-offers__modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const activeModal = document.querySelector('.store-offers__modal.is-open');
    if (activeModal) closeModal(activeModal);
  });
})();
